export default __webpack_public_path__ + "static/media/dodgeball-icon.d30060a6.svg";